import { OptionsArray } from '@/scripts/extends';
import { isDebug } from '@/scripts/utils/devUtils';
import MinuteIcon from './images/minute.svg?react';
import HourIcon from './images/hour.svg?react';
import DayIcon from './images/day.svg?react';
import WeekIcon from './images/week.svg?react';
import AvatarMinuteIcon from './images/avatar/minute.svg?react';
import AvatarHourIcon from './images/avatar/hour.svg?react';
import AvatarDayIcon from './images/avatar/day.svg?react';
import AvatarWeekIcon from './images/avatar/week.svg?react';

export const msgExpireDurationIcon = <WeekIcon />;

export const msgExpireDurationOptions = new OptionsArray([
  {
    key: 'minute',
    value: 60 * 1000,
    label: (
      <Flex align="center" gap={2}>
        <MinuteIcon />
        <div>After 1 minute</div>
      </Flex>
    ),
    tag: '1 minute',
    icon: <MinuteIcon />,
    avatarIcon: <AvatarMinuteIcon />,
  },
  {
    key: 'hour',
    value: 60 * 60 * 1000,
    label: (
      <Flex align="center" gap={2}>
        <HourIcon />
        <div>After 1 hour</div>
      </Flex>
    ),
    tag: '1 hour',
    icon: <HourIcon />,
    avatarIcon: <AvatarHourIcon />,
  },
  {
    key: 'day',
    value: 24 * 60 * 60 * 1000,
    label: (
      <Flex align="center" gap={2}>
        <DayIcon />
        <div>After 1 day</div>
      </Flex>
    ),
    tag: 'one day',
    icon: <DayIcon />,
    avatarIcon: <AvatarDayIcon />,
  },
  {
    key: 'week',
    value: 7 * 24 * 60 * 60 * 1000,
    label: (
      <Flex align="center" gap={2}>
        <WeekIcon />
        <div>After 1 week</div>
      </Flex>
    ),
    tag: 'one week',
    icon: <WeekIcon />,
    avatarIcon: <AvatarWeekIcon />,
  },
]);

if (isDebug) {
  msgExpireDurationOptions.unshift({
    key: 'half-minute',
    value: 20 * 1000,
    label: <div>After 20 seconds</div>,
    tag: '20 seconds',
    icon: <MinuteIcon />,
    avatarIcon: <AvatarMinuteIcon />,
  });
}

export const defaultMsgExpireDuration = msgExpireDurationOptions.findValue('week')!;
